export default __webpack_public_path__ + "static/trustedIcon2-280c04fd20466688c99f8558eb5a4bb7.png";